"use client";
//#region packages/@mantine/core/src/components/Modal/Modal.module.css
var Modal_module_default = {
	"root": "m_9df02822",
	"content": "m_54c44539",
	"inner": "m_1f958f16",
	"header": "m_d0e2b9cd"
};
//#endregion
export { Modal_module_default as default };

//# sourceMappingURL=Modal.module.mjs.map